import { Slider } from 'antd';
import React from 'react';
import { SoundOutlined } from '@ant-design/icons';
import { useAppState, ActionType } from '../../state/AppState';

const VolumeControls = () => {
  const { dispatch, masterVolume, masterMuted } = useAppState();
  const volume = masterMuted ? 0 : Math.round(masterVolume * 100);
  return (
    <div className='volume-controls'>
      <div
        className='b-volume'
        style={{
          zIndex: 10000,
          // width: 100,
          // position: 'absolute',
          // right: 0,
          // transform: 'translateX(-120%)',
          // transform: 'translateX(100%)',
          // top: '50%',
          // height: '100%',
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}>
        {/* <div
        style={{
          height: '80%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}> */}
        <SoundOutlined
          style={{ color: masterMuted ? 'gray' : '#e45683', cursor: 'pointer', paddingRight: 10 }}
          onClick={() => {
            dispatch({
              type: ActionType.MuteMaster,
              muted: !masterMuted,
            });
          }}
        />
        <div style={{ width: '100%' }}>
          <Slider
            min={0}
            max={100}
            value={volume}
            onChange={(value: number) => {
              dispatch({
                type: ActionType.SetVolume,
                volume: typeof value === 'number' ? value / 100 : value[1],
              });
            }}
          />
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default VolumeControls;
